$(function (){

  var url = document.location.toString();

  if (url.match('#')) {
    $('.nav-tabs a[href="#' + url.split('#')[1].replace('-tab', '') + '"]').tab('show');
  }

  // Change hash for page-reload
  $('.nav-tabs a').on('shown.bs.tab', function (e) {
    window.location.hash = e.target.hash + "-tab";
  });



});



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/bootstrap_tabs.js